import { DateTimePicker } from '@mui/x-date-pickers';
import styled from 'styled-components';

export const TimestampDateTimePicker = styled(DateTimePicker)`
  width: 323px;

  svg[data-testid='CalendarIcon'] {
    position: absolute;
    left: -295px;
  }

  ${({ readOnly }) =>
    readOnly &&
    `
    .MuiInputBase-root {
      border-color: transparent;
      cursor: not-allowed;
    }
  `}
`;
